import React from "react";
import { cn } from "../../lib/utils";
import { MapCustomMapLibraryCard } from "./MapCustomMapLibraryCard";
import type { MapCustomMapCollectionProps } from "../../contracts/map-custom-maps";

export function MapCustomMapCollection({
  items,
  emptyState,
  loading,
  onAction,
  className,
}: MapCustomMapCollectionProps) {
  if (loading) {
    return (
      <div className={cn("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6", className)}>
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="flex flex-col bg-card border rounded-xl overflow-hidden animate-pulse"
          >
            <div className="aspect-[16/9] bg-muted" />
            <div className="p-5 flex flex-col gap-4">
              <div className="space-y-2">
                <div className="h-4 w-3/4 bg-muted rounded" />
                <div className="h-3 w-1/2 bg-muted rounded" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="h-3 bg-muted rounded" />
                <div className="h-3 bg-muted rounded" />
              </div>
              <div className="mt-4 h-10 bg-muted rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0 && emptyState) {
    return <div className={cn("flex flex-col items-center justify-center py-20 px-6", className)}>{emptyState}</div>;
  }

  return (
    <div
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6",
        className
      )}
    >
      {items.map((item) => (
        <MapCustomMapLibraryCard
          key={item.id}
          item={item}
          onAction={onAction}
        />
      ))}
    </div>
  );
}
